<style lang="less">
@import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>购买版权保险</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="../user/more/images/ty_close.png" alt='版权登记'/>
            </div>
            <!-- <p class="modal-title">选择订单</p> -->
            <Tabs value="name1">
                <TabPane label="存证作品" name="name1">
                    <div>
                        <Row class="invice-table-title">
                            <i-col span="2">选择</i-col>
                            <i-col span="8">投保作品</i-col>
                            <!-- <i-col span="4">确权方式</i-col> -->
                            <i-col span="7">被保险人</i-col>
                            <i-col span="7">确权时间</i-col>
                        </Row>
                        <div  v-if="recordsCert.length>0">
                            <div style="height:304px;">
                                <Row class="invice-table-content" v-for="(item,index) in recordsCert" :key="index">
                                <i-col span="2"><img :src="currentIndexCert==index?yes:no" class="imgbox" @click="selectItemCert(index,item.orderSeqNo)" alt='版权登记'/></i-col>   
                                <i-col span="8" class="onecol">
                                    <Tooltip style="margin: 0" :content="item.title" placement="bottom">
                                        <div style="margin:0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:160px;">
                                            {{ item.title }}
                                        </div>
                                    </Tooltip>
                                </i-col>
                                <i-col span="7">{{item.sponsor}}</i-col>
                                <i-col span="7">{{item.time}}</i-col>
                                </Row>
                            </div>
                            <div class="commont-page">
                                <Page :page-size="pageSizeCert"  @on-change="changepageCert" :total="totalCert" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pagesCert}}页</span>
                            </div> 
                            <div style="text-align:center;margin-top:35px;"> 
                                <button class="getBtn" @click="applyBillCert" :disabled="applyBillFlagCert">上保险 </button>
                            </div>   
                        </div>            
                        <div class="empty-box" v-if="recordsCert.length<=0" style="margin-left:150px;">
                            <img src="../user/more/images/empty.png" class="empty-img" alt='版权登记'/>
                            <p>表单暂无数据哦～</p>
                        </div>  
                    </div>
                </TabPane>
                <TabPane label="登记作品" name="name2">
                    <Row class="invice-table-title">
                            <i-col span="2">选择</i-col>
                            <i-col span="8">投保作品</i-col>
                            <i-col span="7">被保险人</i-col>
                            <i-col span="7">确权时间</i-col>
                        </Row>
                        <div  v-if="recordsRegister.length>0">
                            <div style="height:304px;">
                                <Row class="invice-table-content" v-for="(item,index) in recordsRegister" :key="index">
                                <i-col span="2"><img :src="currentIndexRegister==index?yes:no" class="imgbox" @click="selectItemRegister(index,item.orderSeqNo)" alt='版权登记'/></i-col>   
                                <i-col span="8" class="onecol">
                                    <Tooltip style="margin: 0" :content="item.title" placement="bottom">
                                        <div style="margin:0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:160px;">
                                            {{ item.title }}
                                        </div>
                                    </Tooltip>
                                </i-col>
                                    <i-col span="7">{{item.sponsor}}</i-col>
                                    <i-col span="7">{{item.time}}</i-col>
                                </Row>
                            </div>
                            <div class="commont-page">
                                <Page :page-size="pageSizeRegister"  @on-change="changepageRegister" :total="totalRegister" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pagesRegister}}页</span>
                            </div> 
                            <div style="text-align:center;margin-top:35px;"> 
                                <button class="getBtn" @click="applyBillRegister" :disabled="applyBillFlagRegister">上保险 </button>
                            </div>   
                        </div>            
                        <div class="empty-box" v-if="recordsRegister.length<=0" style="margin-left:150px;">
                            <img src="../user/more/images/empty.png" class="empty-img" alt='版权登记'/>
                            <p>表单暂无数据哦～</p>
                        </div>  
                </TabPane>
            </Tabs>
            <Spin size="large" fix v-if="spinShow"></Spin>        
        </div>
       <!-- 是否支付成功 -->
        <!-- <paySuccess @fatherModal="payModal" v-if="isShowModal" ref="payChildModal"></paySuccess> -->
    </div>
</template>

<script>
import Cookies from "js-cookie";
// import paySuccess from './insurancePay';
import {getBuyInsurance,getShangInsurance,getInsuranceUrl} from '@/api/staticPage';
    export default {
        name:'insuranceModel',
        props:{
            mywidth:{
                type:String,
                default:'600'
            },
            myheight:{
                type:String,
                default:'650'
            },
            myTitleheight:{
                type:String,
                default:'63'
            },
            tishihide:{
                type:Boolean,
                default:true
            }
        },
        components: {
        },
        data(){
            return{
                isShowModal:false,
                loading: true,
                totalRegister:0,
                pagesRegister:0,
                pageNumberRegister:1,
                pageSizeRegister:5,
                recordsRegister:[],
                flagRegister:false,
                recordListRegister:[],
                billIdRegister:'',
                currentIndexRegister:null,
                yes: require('./images/yes.png'),
                no:require("./images/no.png"),
                applyBillFlagRegister:false, //申请按钮多次点击
                totalCert:0,
                pagesCert:0,
                pageNumberCert:1,
                pageSizeCert:5,
                recordsCert:[],
                flagCert:false,
                recordListCert:[],
                billIdCert:'',
                currentIndexCert:null,
                applyBillFlagCert:false ,//申请按钮多次点击
                spinShow: false
            }
        },
        methods:{
            parentHandleclick() {
               this.$emit('fatherModal');
            },  
            //获取登记列表
            _getBuyInsurance(){
                const data={
                    pageNumber:this.pageNumberRegister,
                    pageSize:this.pageSizeRegister,
                    type:0
                }
                getBuyInsurance(data).then(res => {
                    if(res.code==200){
                        console.log(res)
                        this.totalRegister=Number(res.result.total);
                        this.pagesRegister=res.result.pages;
                        this.recordsRegister=res.result.records;
                    }                                        
                });
            },
            //获取存证列表
            getCzList(){
                this.spinShow = true;
                const data={
                    pageNumber:this.pageNumberCert,
                    pageSize:this.pageSizeCert,
                    type:1
                }
                getBuyInsurance(data).then(res => {
                    if(res.code==200){
                        this.spinShow = false;
                        this.totalCert=Number(res.result.total);
                        this.pagesCert=res.result.pages;
                        this.recordsCert=res.result.records;
                    } else{
                        this.spinShow = false;
                        toast(res.message)
                    }                                       
                });
            },
            //存证分页
            changepageCert(index){
                this.pageNumberCert = index;
                this.currentIndexCert=null
                this.billIdCert=""
                this.getCzList()
            }, 
            //登记分页
            changepageRegister(index){
                this.pageNumberRegister = index;
                this.currentIndexRegister=null
                this.billIdRegister=""
                this._getBuyInsurance()
            }, 
            //登记单选
            selectItemRegister(index,id){
                this.currentIndexRegister=index
                this.billIdRegister=id;
                console.log(id)
                this.$emit('refSeqNo',id,0);
            },
            //存证单选
            selectItemCert(index,id){
                console.log(index)
                console.log(id)
                this.currentIndexCert=index
                this.billIdCert=id;
                this.$emit('refSeqNo',id,1);
            },
            //登记上保险
            applyBillRegister(){
                this.applyBillFlagRegister = true;
                let data = {
                    refSeqNo:this.billIdRegister,
                    type:0
                }
                if(this.billIdRegister){
                    getInsuranceUrl(data).then(res=>{
                        if(res.code == 200){
                            window.open(res.result)
                            // this.$emit('updateBillData');
                            this.$emit('fatherModal');
                            // toast("成功上保险")
                             this.applyBillFlagRegister = false;
                        }else{
                             this.applyBillFlagRegister = false;
                            toast(res.message)
                        }
                    })
                }else{
                    toast("请先选择订单")
                    this.applyBillFlagRegister = false;
                }
            },
            //存证上保险
            applyBillCert(){
                this.applyBillFlagCert = true;
                let data = {
                    refSeqNo:this.billIdCert,
                    type:1
                }
                if(this.billIdCert){
                    getInsuranceUrl(data).then(res=>{
                        if(res.code == 200){
                            window.open(res.result)
                            // this.isShowModal = true;
                            // this.$emit('updateBillData');
                            this.$emit('fatherModal');
                            // toast("成功上保险")
                             this.applyBillFlagCert = false;
                        }else{
                             this.applyBillFlagCert = false;
                            toast(res.message)
                        }
                    })
                }else{
                    toast("请先选择订单")
                    this.applyBillFlagCert = false;
                }
            }
        },
        mounted(){
           this._getBuyInsurance();
           this.getCzList();
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        /deep/ .ivu-tabs-bar{
            border-bottom: none;
            margin: 20px auto;
            margin-left: 200px;
        }
        /deep/ .ivu-tabs-ink-bar{
            width: 24px !important;
            height: 4px;
            left:38px;
            background: #ffd800;
            border-radius: 4px;
        }
        /deep/ .ivu-tabs-nav{
            /deep/ .ivu-tabs-tab-active{
                font-size: 18px;
                font-weight: 600;
                color: #323232;
            }
            /deep/ .ivu-tabs-tab{
                // padding:0;
                // margin-right: 36px;
            }
        }
        /deep/ .ivu-tabs-tab:hover{
            color: #323232;
        }
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .modal-title{
                margin:15px 0 9px 20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                text-align: left;
            }
            .invice-table-title{
                width:559px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:rgba(251,251,251,1);
                margin:0 20px;
            }
            .invice-table-content{
                width: 559px;margin: 0 auto;
                font-size:14px;
                font-weight:400;
                color:rgba(153,153,153,1);
                border-bottom: 1px solid #EEEEEE;
                div{
                    margin:15px 0;
                    /*width:200px;*/
                    height: 20px;
                    line-height: 1;
                    /*overflow: hidden;*/
                    /*text-overflow: ellipsis;*/
                    /*white-space: nowrap;*/
                }
                .onecol{
                    text-align: left;
                    padding-left: 10px;
                }
                .imgbox{
                    width: 12px;
                    height: 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    vertical-align: super;
                }
            }
            .getBtn{
                width:124px;
                height:42px;
                line-height: 42px;
                border:0;
                background:rgba(255,216,0,1);
                border-radius:4px;
                text-align: center;
                outline: none;
                font-size:14px;
                font-weight:400;
                color:rgba(25,25,25,1);
                cursor: pointer;
            }
        }
    }
</style>